// Shared request handling. Keep the existing API response shape for callers.
import Vue from 'vue';
import axios from 'axios';
import { Toast } from 'vant';
Vue.use(Toast);

axios.defaults.timeout = 10000;

axios.interceptors.request.use(config => config, error => Promise.reject(error));
axios.interceptors.response.use(
  response => {
    if (response.status === 200 && response.data && response.data.status == 200) {
      return response;
    }
    Toast((response.data && response.data.msg) || 'Request failed. Please try again.');
    return Promise.reject(response);
  },
  error => {
    const response = error.response;
    Toast((response && response.data && response.data.msg) ||
      (error.code === 'ECONNABORTED' ? 'Request timed out. Please try again.' : 'Request failed. Please try again.'));
    return Promise.reject(error);
  }
);

export default {
  get(path = '', data = {}) {
    return axios.get(path, { params: data }).then(response => response.data);
  },
  post(path = '', data = {}) {
    return axios.post(path, data).then(response => response.data);
  }
};
